import React from "react";

import { Box, FormControl, InputLabel, MenuItem, Radio, Select, SelectChangeEvent } from "@mui/material";


import { useTranslation } from "react-i18next";


import * as Api from "api/api";
import * as F from 'tsui/Form';

import { alertObject } from "../../../tsui/AlertObject";
import ProgressModal from "../../../tsui/ProgressModal";

interface AddUserProps {
    onClose: () => void;
}
export default function ProduceCardsModal(props: AddUserProps) {
    const form = F.useForm({ type: 'input' });
    const [busy, setBusy] = React.useState(false);

    const [cardType, setCardType] = React.useState('');
    const cardTypeRef = React.useRef<string | null>(null)
    const [t] = useTranslation();

    const handleCardTypeChange = (event: SelectChangeEvent) => {
        setCardType(event.target.value);
        cardTypeRef.current = event.target.value;
    };

    //const buttonRef = React.useRef<HTMLButtonElement>();

    const onSubmit = React.useCallback((evt: F.InputFormEvent) => {

        let cardType = cardTypeRef.current;

        if (!cardType) {
            alert("Please Select Card Type");
            return;
        }

        let count = evt.data.count
        if (!count || +count <= 0) {
            alert("Card count must be >= 1");
        }

        setBusy(true);

        Api.requestSessionJson('cards', 'produce', { count: count, cardType: cardType }, {}).then(d => {
            setBusy(false);
            alertObject(d);
            props.onClose();
        }).catch(alert);
    }, []);

    return <F.PageFormDialog title='Produce New Cards' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}>

        <Box sx={{ width: 800, mt: 1 }}>
            <F.InputText label='Cards Count' id='count' form={form} xs={5} />
        </Box>

        <Box sx={{ minWidth: 120, mt: 3 }}>
            <FormControl fullWidth>
                <InputLabel id="card-type-select">Card Type</InputLabel>
                <Select
                    labelId="card-type-select"
                    value={cardType}
                    onChange={handleCardTypeChange}
                    label="Card Type"
                >
                    <MenuItem key='P' value='P'>Personal</MenuItem>
                    <MenuItem key='B' value='B'>Business</MenuItem>
                </Select>
            </FormControl>
        </Box>

        <ProgressModal show={busy} title="Producing..."/>

    </F.PageFormDialog>
}
